// extracted by mini-css-extract-plugin
export var VariantChoice = "VariantChoice_s7ib8";